import { type MealQueueItem } from '@/apiClients/mpq';
import { config } from '@/config';
import { useRegionalApis } from '@/context/RegionScope';

// Kept apart from MealPhoto.tsx so the queue landing page, which only needs the URL, does not pull the
// image zoom library into the entry chunk. The default host is config.API_URL so this file also does
// not import the food and meal clients.
export const getMealPhotoUrl = (
  queue: MealQueueItem,
  size: 'original' | 'resized',
  apiUrl: string = config.API_URL,
) => {
  if (!queue.meal_photo_id) {
    return null;
  }
  return apiUrl + `/api/meal_photos/${queue.meal_photo_id}/` + (size === 'original' ? 'original_photo' : 'photo');
};

/** Meal photo URL on the host of the current region scope. */
export const useMealPhotoUrl = (queue: MealQueueItem, size: 'original' | 'resized') => {
  const { apiUrl } = useRegionalApis();
  return getMealPhotoUrl(queue, size, apiUrl);
};

/** The patient's recording for a meal logged by voice, read through the queue item so access follows the queue. */
export const getMealAudioUrl = (queue: MealQueueItem, apiUrl: string = config.API_URL) => {
  if (!queue.meal_audio_id) {
    return null;
  }
  return (
    apiUrl + `/api/data_reviewer_group/${queue.data_reviewer_group_id}/meal_photo_queue/${queue.id}/original_audio`
  );
};

/** Meal audio URL on the host of the current region scope. */
export const useMealAudioUrl = (queue: MealQueueItem) => {
  const { apiUrl } = useRegionalApis();
  return getMealAudioUrl(queue, apiUrl);
};
